import { baseApi } from "../../api/baseApi";

export const authApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation({
      query: (body) => ({
        url: "/login",
        method: "POST",
        body,
      }),
      invalidatesTags: ["AuthProfile"],
    }),
    refreshToken: build.mutation({
      query: (body) => ({
        url: "/getrefreshtoken",
        method: "POST",
        body,
      }),
      invalidatesTags: ["AuthProfile"],
    }),
    logout: build.mutation({
      query: () => ({
        url: "/logout",
        method: "POST",
      }),
    }),
    getAuthProfile: build.query({
      query: () => ({
        url: "/api/auth/profile",
        method: "GET",
      }),
      providesTags: ["AuthProfile"],
      refetchOnMountOrArgChange: true,
      refetchOnFocus: true,
    }),
  }),
  overrideExisting: false,
});

export const { useLoginMutation, useRefreshTokenMutation, useLogoutMutation, useGetAuthProfileQuery } = authApi;
